import { type KC_ButtonProps, KC_ButtonSize, KC_ButtonType } from "./KC_Button";
import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.scss";
import { type SizeProp } from "@fortawesome/fontawesome-svg-core";

interface IconButtonProps extends KC_ButtonProps {
  icon?: any;
}

export default function KC_Icon_Button(props: IconButtonProps) {
  const {
    id,
    extraStyle,
    customIcon,
    disabled = false,
    className = "",
    onClick,
    size = KC_ButtonSize.Medium,
    type = KC_ButtonType.Button,
    isPrimary,
    isInverted,
    isSecondary,
    icon
  } = props;

  const btnSize = useMemo(() => `btn_icon_${size}`, [size]);

  const btnClsName = useMemo(() => {
    return [
      "kc_icon_button",
      className,
      btnSize,
      disabled ? "btn_disabled" : "",
      isPrimary ? "btn_primary" : "",
      isInverted ? "btn_inverted" : "",
      isSecondary ? "btn_secondary" : ""
    ]
      .filter(Boolean)
      .join(" ");
  }, [size, btnSize, disabled, isPrimary, isInverted, isSecondary, className]);

  const icon_size = useMemo(() => {
    switch (props.size) {
      case KC_ButtonSize.Large:
        return "1x";
      case KC_ButtonSize.Medium:
        return "sm";
      case KC_ButtonSize.Small:
        return "xs";
      default:
        return "1x";
    }
  }, [size]);

  return (
    <button
      id={id}
      className={` ${btnClsName}`}
      type={type || KC_ButtonType.Button}
      onClick={onClick}
      style={extraStyle}
    >
      {customIcon != null ? (
        customIcon
      ) : (
        <FontAwesomeIcon icon={icon} size={icon_size as SizeProp} />
      )}
    </button>
  );
}
